import api from '../..'
import { ILessonModel } from 'models/lesson.model'

export const editLessonsOrder = async (lessons: ILessonModel[]) => {
  await Promise.all(
    lessons.map(async ({ id }: ILessonModel, index: number) => {
      if (id) return api.patch(`administration/lessons/${id}`, { lesson: { order: index + 1 } })
    })
  )
}
export const editLesson = (lessonId: string, data: ILessonModel) => {
  return api.patch(`administration/lessons/${lessonId}}`, data)
}
